module.exports = __webpack_public_path__ + "assets/img/head-bj.ef09e6a3.png";